import moment from "moment-timezone"
import {useRawTranslation} from "../../../effects/use_translation";

export function getNtranslation(key) {
  const rTranslation = useRawTranslation()
  return rTranslation(key)
}
